import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import {
  DataProtectionNoticeCountriesListLoad,
  DataProtectionNoticeCountriesListInitialState,
} from './data-protection-notice-countries-list.actions';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import {
  DataProtectionNoticeCountriesListState,
  DpnCountriesListStateModel,
} from './data-protection-notice-countries-list.state';

@Injectable({ providedIn: 'root' })
export class DataProtectionNoticeCountriesListFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<DpnCountriesListStateModel> = this.store.select(DataProtectionNoticeCountriesListState.getState);
  items$: Observable<string[]> = this.store.select(DataProtectionNoticeCountriesListState.getItems);
  loaded$: Observable<boolean> = this.store.select(DataProtectionNoticeCountriesListState.getLoaded);

  constructor(private store: Store) {}

  loadAll(): void {
    this.store.dispatch(new DataProtectionNoticeCountriesListLoad());
  }

  setInitialState(): void {
    this.store.dispatch(new DataProtectionNoticeCountriesListInitialState());
  }
}
